<template>
    <div>
        <div v-if="logined && bus.code !== 83001003 && bus.username">
            <simple-menu :menu-list="menuList"></simple-menu>
            <div class="small-app-content">
                <router-view :app-info="appInfo"></router-view>
            </div>
        </div>
        <access-deny v-else></access-deny>
    </div>
</template>
<script>
import SimpleMenu from '@/components/Menu';
import AccessDeny from '@/components/AccessDeny.vue';
import dao from '@/lib/dao.js';
import bus from '@/lib/bus.js';

export default {
    components: {
        SimpleMenu,
        AccessDeny
    },
    data() {
        return {
            menuList: [
                {
                    name: '设置',
                    route: '/app/setting'
                },
                {
                    name: '开发管理',
                    route: '/app/devmng'
                },
                {
                    name: '权限管理',
                    route: '/app/rightsmng'
                },
                {
                    name: '关联up主',
                    route: '/app/upmng'
                },
                {
                    name: '支付能力',
                    route: '/app/payment'
                },    
                {
                    name: '开发文档更新',
                    route: '/app/log'
                }
            ],
            appInfo: {},
            bus,
            logined: true
        }
    },
    created() {
        dao.shop.getCompanyInfo().then(data => {
            bus.username = data;
            bus.type = 'shop';
            let id = this.$route.params.appId;
            this.menuList[0].route += '/' + id;
            this.menuList[1].route += '/' + id;
            this.menuList[2].route += '/' + id;
            this.menuList[3].route += '/' + id;
            this.menuList[4].route += '/' + id;
            this.menuList[5].route += '/' + id;
            dao.shop.getAppDetail({appId: id}).then(data => {
                this.appInfo = data || {};
                this.appInfo.type === 1 ? this.menuList[4].name = '虚拟支付能力' : '';
                this.appInfo.type === 1 ? this.menuList.splice(3, 1) : '';
                bus.smallAppName = data.name;
                bus.mid = data.mid;
            }).catch(msg => {
                this.$message.error(msg);
            });
        }).catch(response => {
            bus.code = response.code;
            if (response.code === 83001002) {
                this.logined = false;
            } else if (response.code !== 83001003) {
                this.$message.error(response.message);
            }
        });
    }
}
</script>
<style lang="less" scoped>
.small-app-content {
    display: inline-block;
    width: 1015px;
    margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/page/manage/Main.vue